// src/components/LectureFaqMenu.js
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

const MENU_T = {
  en: {
    faqMenuTitle: "STT FAQ Menu",
    faqMenuHowToUse: "How to Use",
    faqMenuTips: "Recording & Upload Tips",
    faqMenuLanguage: "Supported Languages",
    faqMenuPrivacy: "Privacy & Data",
    faqMenuVersion: "Version & Updates",
    faqMenuSupport: "Support / Contact",
    faqMenuAll: "View all STT FAQs",
  },
  "zh-Hant": {
    faqMenuTitle: "STT 常見問題選單",
    faqMenuHowToUse: "如何使用",
    faqMenuTips: "錄音與上傳貼士",
    faqMenuLanguage: "支援語言",
    faqMenuPrivacy: "隱私與數據",
    faqMenuVersion: "版本與更新記錄",
    faqMenuSupport: "支援／聯絡我們",
    faqMenuAll: "查看全部 STT 常見問題",
  },
  "zh-Hans": {
    faqMenuTitle: "STT 常见问题菜单",
    faqMenuHowToUse: "如何使用",
    faqMenuTips: "录音与上传贴士",
    faqMenuLanguage: "支持语言",
    faqMenuPrivacy: "隐私与数据",
    faqMenuVersion: "版本与更新记录",
    faqMenuSupport: "客户／联系我们",
    faqMenuAll: "查看全部 STT 常见问题",
  },
};

function detectUiLocale(navUploadLabel) {
  if (!navUploadLabel) return "en";
  if (navUploadLabel === "Upload") return "en";
  if (navUploadLabel.includes("上傳") || navUploadLabel.includes("上传"))
    return navUploadLabel.includes("上传") ? "zh-Hans" : "zh-Hant";
  if (/[\u4e00-\u9fff]/.test(navUploadLabel)) return "zh-Hant";
  return "en";
}

const LectureFaqMenu = ({ active }) => {
  const { t } = useLanguage();
  const navUploadLabel = t ? t("navUpload") : "Upload";
  const uiLocale = detectUiLocale(navUploadLabel);
  const strings = useMemo(() => MENU_T[uiLocale] || MENU_T.en, [uiLocale]);

  const linkClass = (key) =>
    `stt-faq-menu-link${active === key ? " stt-faq-menu-link--active" : ""}`;

  return (
    <aside className="upload-aside upload-aside--faq stt-faq-menu-card howto-aside">
      <h2 className="upload-aside-title">{strings.faqMenuTitle}</h2>
      <ul className="stt-faq-menu-list">
        <li>
          <Link
            to="/lecture/faq/how-to-use"
            className={linkClass("how-to-use")}
          >
            {strings.faqMenuHowToUse}
          </Link>
        </li>
        <li>
          <Link
            to="/lecture/faq/privacy"
            className={linkClass("privacy")}
          >
            {strings.faqMenuPrivacy}
          </Link>
        </li>
        <li>
          <Link
            to="/lecture/faq/version"
            className={linkClass("version")}
          >
            {strings.faqMenuVersion}
          </Link>
        </li>
        <li>
          <Link
            to="/lecture/faq/support"
            className={linkClass("support")}
          >
            {strings.faqMenuSupport}
          </Link>
        </li>
      </ul>
      <div className="stt-faq-menu-footer">
        <Link
          to="/lecture/faq"
          className={linkClass("faq")}
        >
          {strings.faqMenuAll}
        </Link>
      </div>
    </aside>
  );
};

export default LectureFaqMenu;
